import types from '../actionTypes';

export const setNewPin = payload => ({
    type: types.SET_NEW_PIN,
    payload,
});

export const removeNewPin = () => ({
    type: types.REMOVE_NEW_PIN,
});
